import { Component, ViewChild, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA} from '@angular/material';
import { Router } from '@angular/router';
import { ImportarDialog } from '../../../components/personas/dialog-importar/importar-dialog.component';
import { VerContactosComponent } from '../../../forms/contactos/ver-contactos/ver-contactos.component';
import { VerEstadosPropuestaComponent } from '../../../forms/estados-propuesta/ver-estados-propuesta/ver-estados-propuesta.component';
@Component({
  selector: 'app-contactos',
  templateUrl: './contactos.component.html',
  styleUrls: ['./contactos.component.scss']
})
export class ContactosComponent {
  @ViewChild('verContactos') verContactos: VerContactosComponent
  accionesContacto: boolean = true;
  constructor(
    private router: Router,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  //  console.log(this.verEstadoPropuesta);
  }

  importarContactos(){
    let dialogImportar = this.dialog.open(ImportarDialog, {
      disableClose: true,
      data:{
        "tipo": "contacto"
      }
    });

    dialogImportar.afterClosed().subscribe(closed => {
      // this.actualizarListado();
      this.verContactos.actualizarTabla();
    });
  }

  actualizarTabla(): void {
    this.verContactos.actualizarTabla();
  }
}
